module.exports = __webpack_public_path__ + "img/logo-header.47446f12.png";